import styled from 'styled-components';

export const RelativeOverlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const PaywallaxSelector = styled.div`
  width: 100%;
  margin: auto;
  z-index: 99999;

  @keyframes slideUp {
    from { transform: translateY(0%); }
    to { transform: translateY(-100%); }
  }

    &.initial {
      display: none;
    }

    &.loaded {
      position: fixed;
      top: 100dvh;
      left: 0;
      right: 0;
      animation-name: slideUp;
      animation-duration: 1s;
      animation-fill-mode: forwards;
      /* transform: translateY(-100%); */
    }
`;
